import { ACTION_TYPES } from './constants';

export const initializeFingerprint = (code) => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.FINGERPRINT_INITIALIZED,
        payload: code
    });
};

export const initialize = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.INITIALIZE
    });
};
